// UI application module aggregator
angular.module('ui',
    [
        'ui.shell',
        'ui.login',
        'ui.pwdReset',
        'ui.loadingShadow',
        'ui.appReload',
        'ui.error',
        'ui.order',
        'ui.customer',
        'ui.centre',
        'ui.report',

        'ui.omqlTester'
    ]);
